import { useQueryClient } from '@tanstack/react-query';

import type { UUID } from '@/utils/uuid';

import { connectorQueryKeys } from './query-keys';

/**
 * Returns a callback that invalidates the configuration-status cache entry for
 * a specific connector, forcing the setup page to re-evaluate whether
 * credentials have been applied.
 */
export function useInvalidateConnectorConfigurationStatus(
  tenantId: UUID | undefined,
  connectorId: UUID | undefined
) {
  const qc = useQueryClient();

  return () => {
    void qc.invalidateQueries({
      queryKey: connectorQueryKeys.configurationStatus(tenantId, connectorId),
    });
  };
}
